import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-components-view',
  templateUrl: './components-view.component.html',
  styleUrls: ['./components-view.component.scss'],
})
export class ComponentsViewComponent {
  constructor() {}
}
